"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORY_CATEGORY_RELATIONS = void 0;
exports.STORY_CATEGORY_RELATIONS = {
    UNKNOWN: {},
    HEALTH: {
        GROWTH: {
            DIET: {
                NEWBORN_DIET: {},
                PUPPY_DIET: {},
                ADOLESCENCE_DIET: {},
                ADULT_DIET: {}
            },
            EXERCISE: {},
        },
        GROOMING: {
            HAIR: {},
            NAILS: {},
            TEETH: {}
        },
        MEDICAL: {
            VETERINARY: {
                NEUTERING: {},
                VACCINATIONS: {},
            },
            INSURANCE: {}
        }
    },
    TRAINING: {
        BEHAVIOR: {},
        WALKING: {},
        SOCIAL: {},
        HOME: {}
    }
};
